import { render, staticRenderFns } from "./UsersPrivilegeTreasuriesTransaction.vue?vue&type=template&id=00763bc4&scoped=true&"
import script from "./UsersPrivilegeTreasuriesTransaction.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeTreasuriesTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00763bc4",
  null
  
)

export default component.exports